import React from 'react';
import ModuleDashboard from './ModuleDashboard';

export const DepartmentDashboard = props => {
  const {params} = props?.route;
  return <ModuleDashboard params={params} {...props} />;
};
